
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers",
      function () {
        return require("private-next-pages/teachers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers"])
      });
    }
  